import React from "react";
import Homepage from "./Homepage";
import Caratteristiche from "./Caratteristiche";
import Ispirazione from "./Ispirazione";
import Decori from "./Decori";
import Processo from "./Processo";
import ColoriFormati from "./ColoriFormati";
import Collezione from "./Collezione";
import Footer from "./Footer";
import { Provider } from "react-redux";
import { store } from "./app/store";
import Cta from "./Cta";
import FormPage from "./FormPage";
import EfficientCursor from "react-efficient-cursor";
import cursorWrap from "./images/cursor/cursorWrapper.svg";
import cursorPoint from "./images/cursor/cursorPoint.svg";

export default function App() {
	return (
		<div stlye={{ cursor: "none !important" }}>
			<Provider store={store}>
			<EfficientCursor speed={0.8} style={{ cursor: "none" }}>
			<img className="cursor" src={cursorPoint} alt="cursor" />
			</EfficientCursor>
			<EfficientCursor speed={0.8}>
			<img className="cursor" src={cursorWrap} alt="cursor" />
			</EfficientCursor>
			<Homepage />
			<Caratteristiche />
			<Collezione />
			<Decori />
			<Cta />
			</Provider>
		</div>
	);
}